import { render, staticRenderFns } from "./BannerLanding.vue?vue&type=template&id=5c13956e&lang=pug&"
import script from "./BannerLanding.vue?vue&type=script&lang=js&"
export * from "./BannerLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports